import { Pipe, PipeTransform } from '@angular/core';
import { VkPostCardType } from '@shared/components/vk-card/models';

@Pipe({
  name: 'postBtnText'
})
export class VkPostBtnTextPipe implements PipeTransform {
  public transform(type: VkPostCardType, isFinished: boolean): string {
    switch (type) {
      case 'poll':
        return isFinished ? 'MAIN.WATCH_IN_VK' : 'MAIN.VOTE_VK';
      case 'video':
      case 'map':
        return 'MAIN.WATCH_IN_VK';
      case 'text':
        return 'MAIN.READ_IN_VK';
      case 'audio':
        return 'MAIN.LISTEN_ON_VK';
      case 'file':
        return 'MAIN.DOWNLOAD_FROM_VK';
      default:
        return 'MAIN.WATCH_IN_VK';
    }
  }
}
